import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ArticlePromo() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="overflow-hidden rounded-lg bg-primary-600">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
          <div className="p-8 md:p-12">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 text-xs font-semibold text-background-50">
              <i className="ri-book-open-line w-4 h-4 flex items-center justify-center" />
              {t('article.badge')}
            </span>
            <h2 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
              {t('article.title')}
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-100/90 leading-relaxed max-w-xl">
              {t('article.desc')}
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/allchinabuy-spreadsheet"
                className="inline-flex items-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t('article.cta')}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </Link>
              <span className="flex items-center gap-2 text-xs text-background-100/80">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
                {t('article.readTime')}
              </span>
            </div>
          </div>
          <div className="hidden lg:block h-full">
            <img
              src="https://readdy.ai/api/search-image?query=A%20top%20down%20flat%20lay%20of%20an%20open%20notebook%20with%20handwritten%20product%20lists%20next%20to%20a%20laptop%2C%20a%20white%20sneaker%20and%20a%20small%20potted%20plant%20on%20a%20warm%20sage%20and%20cream%20background%2C%20clean%20minimal%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=acb-article-promo&orientation=landscape&nocache=true"
              alt="AllChinaBuy spreadsheet guide"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}